<div class="flex flex-column rtl">
	<section class="client-info">
		<div class="content">
			<div class="client-info-right">
				<div class="row">
					<div class="client-info__title col">פרטים נוספים</div>
				</div>
			</div>
		</div>
	</section>
	<div class="client-profile__block row" (click)="shouldNavigate(row)" *ngFor="let row of data" [ngClass]="{ clickable: isClickable(row) }">
		<div class="flex">
			<div class="client-profile__image image">
				<img src="/assets/images/client-profile/comment-icon.svg" alt="image" />
			</div>
			<div class="client-profile__title" style="font-size: 19px; font-weight: 600">{{ row.HeadLineStr }}</div>
		</div>
		<div class="client-profile__value justify-align-center" *ngIf="row.DataLineStr; else clickableArrowBlock" style="font-size: 19px; font-weight: 600">{{ row.DataLineStr }}</div>
		<ng-template #clickableArrowBlock>
			<div class="client-profile__icon client-profile__icon_arrow-left image col">
				<img src="/assets/images/client-profile/rejected-arrow.svg" alt="image" />
			</div>
		</ng-template>
	</div>
</div>
